import { ButtonHTMLAttributes, useState } from 'react'
import { Box, Button, CircularProgress } from '@mui/material'
import { Plus } from 'lucide-react'

import { cn } from '@/lib/utils'

export type FormSubmitProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'> & {
  isSubmitting?: boolean
}

const FormSubmit = ({ className, children, isSubmitting, ...props }: FormSubmitProps) => {
  const [hovered, setHovered] = useState(false)

  return (
    <Button
      type="submit"
      variant="outlined"
      color="secondary"
      disabled={isSubmitting}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={cn('relative mt-[5.2rem]', className)}
      endIcon={
        isSubmitting ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <Box
            sx={{
              position: 'relative',
              width: '2.6rem',
              height: '2.6rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '0.2rem',
              backgroundColor: hovered ? 'white' : 'transparent',
              transition: 'background-color 0.3s ease',
              '& svg': {
                fontSize: '1.6rem',
                color: hovered ? 'text.primary' : 'white',
                transform: hovered ? 'rotate(90deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease, color 0.3s ease'
              }
            }}
          >
            <Plus />
          </Box>
        )
      }
      sx={{
        typography: 'menu',
        textTransform: 'none',
        height: '4.8rem',
        px: 3,
        borderRadius: (theme) => theme.shape.borderRadius360,
        mt: '5.2rem',
        position: 'relative',
        '&.Mui-disabled': {
          opacity: 0.6
        }
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default FormSubmit
